import { render, staticRenderFns } from "./imger.vue?vue&type=template&id=f8f901f2&scoped=true&"
import script from "./imger.vue?vue&type=script&lang=js&"
export * from "./imger.vue?vue&type=script&lang=js&"
import style0 from "./imger.vue?vue&type=style&index=0&id=f8f901f2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f901f2",
  null
  
)

export default component.exports